import { Button, Col, Form, Input, InputNumber, Modal, Radio, Row, Select, Switch, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addSingleLeavePolicy,
  addSingleLeaveType,
  getDefaultValidity,
  loadAllLeavePolicy,
  loadAllLeaveType,
} from "../../redux/rtk/features/leavePolicy/leavePolicySlice";

const { Option } = Select;

const AddLeavePolicy = () => {
  const { list, loading } = useSelector((state) => state.leavePolicy);
  const [loader, setLoader] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [newLeaveType, setNewLeaveType] = useState("");
  const [creditType, setCreditType] = useState('');
  const defaultValidity = useSelector((state)=> state?.leavePolicy?.defaultValidity);
  console.log("defaultValidity", defaultValidity);
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(loadAllLeavePolicy());
    loadLeaveTypes();
    dispatch(getDefaultValidity())
  }, [dispatch]);

  const loadLeaveTypes = async () => {
    const response = await dispatch(loadAllLeaveType());
    if (response.payload) {
      setLeaveTypes(response.payload);
    }
  };
  const { Title } = Typography;

  const onFinish = async (values) => {
    const FormData = {
      ...values,
      yearlyLimit: values.yearlyLimit.toString(),
      creditLimit: values.creditLimit.toString(),
      monthlyLimit: values.monthlyLimit.toString(),
      unit: values.unit === 'days' ? false : true,
      credit: values.credit === 'annually' ? false : true,
      // validFrom: values.validFrom.toISOString(),
      // validTo: values.validTo.toISOString(),
      paid: values.paid || false,
      carryForward: values.carryForward || false,
      encashable: values.encashable || false,
    };
    setLoader(true);
    const resp = await dispatch(addSingleLeavePolicy(FormData));

    if (resp.payload.message === "success") {
      form.resetFields();
      setLoader(false);
      dispatch(loadAllLeavePolicy());
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed at adding department");
    setLoader(false);
  };
  const handleCreditChange = (e) => {
    setCreditType(e.target.value);
  };

  const handleAddLeaveType = async () => {
    if (newLeaveType) {
      setLoader(true);
      // const resp = await dispatch(addSingleLeaveType({ leaveType: newLeaveType, defaultValidity: defaultValidity }));
      const resp = await dispatch(addSingleLeaveType({ leaveType: newLeaveType, defaultValidity: defaultValidity[0].id }));
      
      if (resp.payload.message === "success") {
        setLoader(false);
        setNewLeaveType("");
        setIsModalVisible(false);
      } else {
        setLoader(false);
      }
    } else {
      toast.warning("Please enter a leave type!");
    }
  };


  return (
    <>
      <Modal
        title="Add Leave Type"
        visible={isModalVisible}
        onOk={handleAddLeaveType}
        onCancel={() => setIsModalVisible(false)}
        confirmLoading={loader}
      >
        <Input
          placeholder="Enter leave type"
          value={newLeaveType}
          onChange={(e) => setNewLeaveType(e.target.value)}
        />
      </Modal>
      <Form
        layout="vertical"
        onFinish={onFinish}
      >

        <Row gutter={1} style={{ marginBottom: 16 }}>

          <Col flex="auto">
            <Form.Item
              name="leaveTypeId"
              label="Leave Type"
              rules={[{ required: true, message: 'Please select a leave type!' }]}
              style={{ marginBottom: 0 }}
            >
              <Select placeholder="Select leave type" loading={loading}>
                {leaveTypes.map((type) => (
                  <Option key={type.id} value={type.id}>
                    {type.leaveType}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col flex="auto" >
            <Button
              onClick={() => setIsModalVisible(true)}
              style={{
                backgroundColor: '#4caf50',
                borderColor: '#4caf50',
                borderRadius: '8px',
                fontWeight: 'bold',
                marginTop: '30px',
              }}
            >
              + Leave Type
            </Button>
          </Col>
        </Row>
        <Form.Item
          name="name"
          label="leave Policy Name"
          rules={[{ required: true, message: 'Please enter the leave Policy Name!' }]}
        >
          <Input placeholder="Enter leave Policy Name" />
        </Form.Item>

        <Form.Item
          name="yearlyLimit"
          label="Max Leaves Per Year"
          rules={[{ required: true, message: 'Please enter the leave limit!' }]}
        >
          <InputNumber min={0} placeholder="Enter number of days" />
        </Form.Item>

        <Form.Item
          // name="leaveLimit"
          name="monthlyLimit"
          label="Max Leaves Per Month"
          rules={[{ required: true, message: 'Please enter the leave limit!' }]}
        >
          <InputNumber min={0} placeholder="Enter number of days" />
        </Form.Item>

        <Form.Item
          name="unit"
          label="Unit"
          rules={[{ required: true, message: 'Please select a unit!' }]}
        >
          <Radio.Group>
            <Radio value="days">Days</Radio>
            <Radio value="hours">Hours</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="credit"
          label="Credit"
          rules={[{ required: true, message: 'Please select a unit!' }]}
        >
          <Radio.Group onChange={handleCreditChange}>
            <Radio value="annually">Annually</Radio>
            <Radio value="monthly">Monthly</Radio>
          </Radio.Group>
        </Form.Item>

        {creditType === 'monthly' && (
          <Form.Item
            name="creditLimit"
            label="Monthly Credit Value"
            rules={[{ required: true, message: 'Please enter the monthly credit value!' }]}
          >
            <InputNumber min={0} placeholder="Enter number of days per month" />
          </Form.Item>
        )}

        {creditType === 'annually' && (
          <Form.Item
            name="creditLimit"
            label="Annual Credit Value"
            rules={[{ required: true, message: 'Please enter the annual credit value!' }]}
          >
            <InputNumber min={0} placeholder="Enter number of days per year" />
          </Form.Item>
        )}

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="paid" label="Is Paid Leave" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="carryForward" label="Allow Carry Forward" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="encashable" label="Encashable" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save Policy
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default AddLeavePolicy;



